import Vue from 'vue'
import Vuex from 'vuex'
import LogRocket from 'logrocket'
import LogRocketVuex from 'logrocket-vuex'
import AsyncUtils from '@/utils/asyncUtils'
import actualities from './actualities'
import events from './events'
import reports from './reports'
import weather from './weather'
import user from './user'
import cities from './cities'
import usefulInfos from './usefulInfos'
import notifications from './notifications'
import favorites from './favorites'
import stores from './stores'
import storeNotifications from './storeNotifications'
import lostObjects from './lostObjects'
import lostPets from './lostPets'
import covid from './covid'
import loyaltyCard from './loyaltyCard'
import storeLoyaltyCard from './storeLoyaltyCard'
import accounts from './accounts'

Vue.use(Vuex)

const store = new Vuex.Store
({
    plugins: [LogRocketVuex(LogRocket)],
    modules:
    {
        actualities,
        events,
        reports,
        weather,
        user,
        usefulInfos,
        cities,
        notifications,
        favorites,
        stores,
        storeNotifications,
        lostObjects,
        lostPets,
        covid,
        loyaltyCard,
        storeLoyaltyCard,
        accounts
    }
})

console.log('Relocating store getters')
for (let [name, getter] of Object.entries(store.getters))
{
    const splittedName = name.split('/')
    var builtPath = store.getters
    for (let path of splittedName)
    {
        const isLastPathPart = splittedName.indexOf(path) == splittedName.length - 1

        if (isLastPathPart)
        {
            if (typeof getter == 'function')
            {
                builtPath[path] = getter
            }
            else
            {
                Object.defineProperty(builtPath, path, {get: () => store.getters[name]})
            }

            break
        }
        else
        {
            builtPath[path] = builtPath[path] || {}
        }

        builtPath = builtPath[path]
    }
}

export default store

export function waitUntilUserIsFetched ()
{
    return new Promise(async (resolve, reject) =>
    {
        // turns out this crappy way works the best.
        // I'm not keen of doing things this way but hey.. it's not that bad..
        while (!store.state.user.hasBeenFetched)
        {
            await AsyncUtils.sleep(500)
        }

        resolve()
    })
}



// WEBPACK FOOTER //
// ./src/stores/index.js